<template>
  <div class="">
    <el-form
      class="add-form signature-form"
      @submit.prevent="checkSignatureInformation"
      @keydown.enter.prevent="() => {}"
      :model="signature"
      label-position="top"
      ref="signatureForm"
    >
      <!-- Organization -->
      <div class="form-wrapper full">
        <el-form-item
          prop="organization.id"
          :rules="[
            {
              required: true,
              message: $t('COMMON.ORGANIZATION_REQUIRED'),
            },
          ]"
        >
          <base-input
            :label="`${$t('COMMON.ORGANIZATION')} (*)`"
            :placeholder="$t('COMMON.ORGANIZATION')"
            v-if="
              $currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS) &&
              !hideOrganization
            "
          >
            <organization-selector
              :organization="signature.organization.id"
              :filterable="true"
              :showAll="false"
              @organizationChanged="
                (organizationId) => {
                  signature.organization.id = organizationId;
                  openOrCloseModelSelector();
                  onFormChanged();
                }
              "
              :disabled="!!signature.id"
            />
          </base-input>
          <validation-error :errors="apiValidationErrors.organization" />
        </el-form-item>
      </div>
      <div class="form-wrapper full my-2">
        <el-checkbox
          :disabled="disableTemplateSelection"
          @input="openOrCloseModelSelector"
          v-model="fromModel"
          >{{ $t("SIGNATURES.FROM_MODEL") }}</el-checkbox
        >
      </div>
      <div v-if="fromModel" class="form-group-wrapper form-model w-100">
        <!-- Filtrer les contrats -->
        <!-- <el-form-item
          class="form-group-wrapper-item"
          :label="`${$t('CONTRACTS.FILTER_CONTRACTS')}`"
          prop="contract_type"
        >
          <el-select
            :name="`${$t('CONTRACTS.CONTRACT_TYPE')}`"
            v-model="contractType"
          >
            <el-option
              v-for="(contract, val) in CONTRACT_TYPES"
              :key="val"
              :value="val"
              :label="`${val ? $t('CONTRACTS.' + val) : ''}`"
            />
          </el-select>
        </el-form-item> -->

        <!-- Sélectionner le contrat -->
        <el-form-item
          class="form-group-wrapper-item w-100"
          :label="`${$t('SIGNATURES.SELECT_MODEL')}`"
          prop="contract.id"
          :rules="[
            {
              required: true,
              message: $t('SIGNATURES.MODEL_REQUIRED'),
            },
          ]"
        >
          <contract-selector
            :contract="signature.contract?.id?.toString()"
            :filterable="true"
            :showAll="false"
            :allowCreate="false"
            :selectedType="contractType"
            :filterOrganization="signature.organization.id"
            :disabled="disableTemplateSelection"
            @contractChanged="contractSelected"
          />
          <validation-error :errors="apiValidationErrors.contract" />
        </el-form-item>
      </div>

      <div class="form-group-wrapper">
        <!-- Title - Name - Description - Email Message -->

        <!-- Esign name -->
        <div class="form-group-wrapper-item full">
          <el-form-item
            prop="name"
            :rules="[
              {
                required: true,
                message: $t('COMMON.NAME_REQUIRED'),
              },
            ]"
          >
            <base-input
              :label="`${$t('COMMON.NAME')} ${!signature.name ? '(*)' : ''}`"
            >
              <el-input
                v-model="signature.name"
                @change="
                  () => {
                    onFormChanged();
                  }
                "
              />
            </base-input>
            <validation-error :errors="apiValidationErrors.name" />
          </el-form-item>
        </div>

      
    <div class="form-group-wrapper">
        <!-- language -->
        <el-form-item
              class="form-group-wrapper-item"
              :label="$t('SIGNATURES.LANGUAGE')"
              prop="meta.language"
            >
              <el-select
                v-model="signature.meta.language"
                :placeholder="$t('SIGNATURES.LANGUAGE')"
                filterable
              >
                <el-option
                  v-for="lang in onespanLanguages"
                  :key="lang.id"
                  :label="lang.label"
                  :value="lang.id"
                ></el-option>
              </el-select>
          <validation-error :errors="apiValidationErrors?.meta?.language" />
        </el-form-item>
        
        <!-- timezone -->
        <el-form-item
              class="form-group-wrapper-item"
              :label="$t('SIGNATURES.TIMEZONE')"
              prop="meta.timezone"
            >
              <el-select
                v-model="signature.meta.timezone"
                :placeholder="$t('SIGNATURES.TIMEZONE')"
                filterable
              >
                <el-option
                  v-for="tz in onespanTimezones"
                  :key="tz.id"
                  :label="tz.label"
                  :value="tz.id"
                ></el-option>
              </el-select>
          <validation-error :errors="apiValidationErrors?.meta?.timezone" />
        </el-form-item>
    </div>

        <!-- Esign Description -->
        <div class="form-group-wrapper-item">
          <base-input
            :label="`${$t('COMMON.EXCERPT')}`"
            :placeholder="`${$t('COMMON.EXCERPT')}`"
            @change="
              () => {
                onFormChanged();
              }
            "
          >
            <textarea
              v-model="signature.description"
              :placeholder="`${$t('COMMON.EXCERPT')}`"
              class="form-control"
              rows="3"
            ></textarea>
          </base-input>
          <validation-error :errors="apiValidationErrors.description" />
        </div>

        <!-- Esign Email Message -->
        <div class="form-group-wrapper-item">
          <base-input
            :label="`${$t('SIGNATURES.EMAIL_MESSAGE')}`"
            :placeholder="`${$t('SIGNATURES.EMAIL_MESSAGE')}`"
            @change="
              () => {
                onFormChanged();
              }
            "
          >
            <textarea
              v-model="signature.email_message"
              :placeholder="`${$t('SIGNATURES.EMAIL_MESSAGE')}`"
              class="form-control"
              rows="3"
            ></textarea>
          </base-input>
          <validation-error :errors="apiValidationErrors.email_message" />
        </div>
      </div>

      <div class="form-group-wrapper">
        <div
          v-if="signature.contract?.id"
          class="signature-data el-form-item form-group-wrapper-item w-100"
        >
          <!-- LES DOCUMENTS DU MODELE A REMPLACER SI BESOIN -->
          <div
            v-if="usingOneSpanSignatureModel && signature.documents?.length"
            class="w-100 mt-3 mb-4 p-3 border rounded bg-secondary-light"
          >
            <h3 class="text-danger mb-2">
              <i class="el-icon-document-copy mr-2"></i>{{ $t("SIGNATURES.MODEL_DOCUMENTS") }}
            </h3>
            <p class="text-muted text-sm mb-3">
              {{ $t("SIGNATURES.YOU_CAN_CHANGE_DOCUMENTS") }}
            </p>
            <el-table :data="signature.documents" border stripe size="small" class="w-100 shadow-sm">
              <el-table-column prop="name" :label="$t('SIGNATURES.DOCUMENT_NAME')">
                <template slot-scope="scope">
                  <span class="font-weight-bold"><i class="el-icon-document mr-1 text-muted"></i> {{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('SIGNATURES.REPLACE_WITH')" width="300">
                <template slot-scope="scope">
                  <div class="d-flex align-items-center">
                    <div v-if="!scope.row.replacement_file_name" class="w-100">
                      <label :for="'file-upload-' + scope.$index" class="btn btn-sm btn-outline-primary mb-0 cursor-pointer w-100">
                        <i class="el-icon-upload2 mr-1"></i> {{ $t("SIGNATURES.SELECT_A_FILE") }}
                      </label>
                      <input 
                        :id="'file-upload-' + scope.$index" 
                        type="file" 
                        style="display: none;" 
                        accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
                        @change="handleDocumentReplacement($event, scope.row)" 
                      />
                    </div>
                    <div v-else class="d-flex align-items-center justify-content-between w-100 px-2 py-1 border rounded bg-white">
                      <span class="text-primary text-truncate d-inline-block mr-2 text-sm" style="max-width: 190px;" :title="scope.row.replacement_file_name">
                        <i class="el-icon-paperclip"></i> {{ scope.row.replacement_file_name }}
                      </span>
                      <el-button 
                        type="danger" 
                        icon="el-icon-close" 
                        size="mini" 
                        circle 
                        plain
                        @click="removeReplacement(scope.row)"
                      ></el-button>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- CONTRACTFILES -->
          <div
            class="documents w-100 mt-3 mb-3"
            v-if="!usingOneSpanSignatureModel && !fromModel"
          >
            <h3 class="text-danger">{{ $t("CONTRACTS.FILES") }}</h3>
            <el-divider />
            <file-list-component :contract="signature.contract" />
          </div>

          <!-- LES DONNEE A RECUPERER POUR REMPLIR LE DOCUMENT -->
          <div class="w-100 mt-3 mb-3" v-if="mustProvidePayload">
            <h3 class="text-danger">
              {{ $t("SIGNATURES.DOCUMENTS_PAYLOAD") }}
            </h3>
            <contract-fields-form
              class="contract-fields-form"
              ref="contract_fields_form"
              v-model="signature.fields"
            />
          </div>

          <!-- EMAIL_MESSAGE -->
          <!-- <el-form-item
            class="form-group-wrapper-item w-100"
            :label="`${$t('SIGNATURES.EMAIL_MESSAGE')} (*)`"
            prop="email_message"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 4 }"
              :placeholder="$t('SIGNATURES.EMAIL_MESSAGE')"
              v-model="signature.email_message"
            >
            </el-input>
            <validation-error :errors="apiValidationErrors.email_message" />
          </el-form-item> -->
        </div>

        <!-- SIGNATAIRES -->

        <!-- Section Signataires -->
        <!-- :rules="[
                { required: true, message: $t('SIGNATURES.SIGNERS_REQUIERED') },
              ]" -->
        <div class="signers w-100 mb-3">
          <el-form-item :prop="'signers'">
            <div class="row">
              <div class="col-md-4 text-start">
                <h3 class="text-danger">
                  {{ $t("SIGNATURES.SIGNERS") }}
                </h3>
              </div>
              <div class="col-md-8 d-flex justify-content-end">
                <!-- Bouton pour ajouter un signataire -->
                <el-button
                  v-if="!usingOneSpanSignatureModel"
                  class="my-3"
                  type="secondary"
                  icon="el-icon-plus"
                  @click="addSigner"
                  style="margin-top: 10px"
                >
                  {{ $t("SIGNATURES.ADD_SIGNER") }}
                </el-button>
              </div>
              <el-divider />
            </div>
            <validation-error :errors="apiValidationErrors.signers" />
          </el-form-item>
          <div
            class="add-signer mb-3"
            v-for="(signer, index) in signature.signers"
            :key="index"
          >
            <div class="delete-signer d-flex justify-content-end">
              <span
                v-if="canRemoveSigner"
                @click="removeSigner(index)"
                class="text-right text-black cursor-pointer font-bold"
              >
                <i class="fa fa-trash"></i>
              </span>
            </div>
            <div class="row">
              <div class="col-md-6">
                <el-form-item
                  :label="$t('COMMON.ROLE')"
                  :prop="'signers.' + index + '.role'"
                  :rules="[
                    { validator: validateUniqueRole, trigger: 'blur' }
                  ]"
                >
                  <el-input
                    :disabled="usingOneSpanSignatureModel || isEditing"
                    v-model="signer.role"
                    :placeholder="$t('COMMON.ROLE')"
                  />
                </el-form-item>
              </div>
              <div class="col-md-6">
                <el-form-item
                  :label="$t('COMMON.EMAIL')"
                  :prop="'signers.' + index + '.email'"
                  :rules="[
                    {
                      required: true,
                      message: $t('COMMON.EMAIL_REQUIRED'),
                    },
                    {
                      type: 'email',
                      message: $t('COMMON.EMAIL_INCORRECT'),
                    },
                  ]"
                >
                  <el-input
                    type="email"
                    v-model="signer.email"
                    :placeholder="$t('COMMON.EMAIL')"
                  />
                </el-form-item>
              </div>
              <div class="col-md-6">
                <el-form-item
                  :label="$t('COMMON.FIRSTNAME')"
                  :prop="'signers.' + index + '.firstname'"
                  :rules="[
                    {
                      required: true,
                      message: $t('COMMON.FIRSTNAME_REQUIRED'),
                    },
                  ]"
                >
                  <el-input
                    v-model="signer.firstname"
                    :placeholder="$t('COMMON.FIRSTNAME')"
                  />
                </el-form-item>
              </div>
              <div class="col-md-6">
                <el-form-item
                  :label="$t('COMMON.LASTNAME')"
                  :prop="'signers.' + index + '.lastname'"
                  :rules="[
                    {
                      required: true,
                      message: $t('COMMON.LASTNAME_REQUIRED'),
                    },
                  ]"
                >
                  <el-input
                    v-model="signer.lastname"
                    :placeholder="$t('COMMON.LASTNAME')"
                  />
                </el-form-item>
              </div>
              <div class="col-md-12">
                <el-form-item
                  :prop="'signers.' + index + '.address'"
                  :label="$t('COMMON.ADDRESS')"
                >
                  <addresses-selector
                    v-model="signer.address"
                    :unique-id="'signer-address-input-' + index"
                    :ref="'signer_address_' + index"
                    :key="'signer_address_' + index"
                    :address="signer.address"
                    @addressInputChangeChanged="
                      (values) => {
                        signer.address = values.formatted_address ?? '';
                      }
                    "
                  />
                </el-form-item>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="usingOneSpanSignatureModel && !signature.id"
          class="form-wrapper full my-2"
        >
          <el-checkbox v-model="sendNow">{{
            $t("SIGNATURES.SEND_FOR_SIGNATURE")
          }}</el-checkbox>
        </div>

        <div class="submit-wrapper">
          <base-button
            type="button"
            class="btn btn-sm elite-submit"
            native-type="submit"
            @click.prevent="checkSignatureInformation"
            :disabled="loading || processing"
          >
            <i class="fas fa-spinner fa-spin" v-if="loading || processing" />
            {{
              signature.id
                ? $t("SIGNATURES.EDIT_SIGNATURE")
                : $t("SIGNATURES.ADD_SIGNATURE")
            }}
          </base-button>
        </div>
      </div>
    </el-form>

    <modal
      :show="showSignatureCheckModal"
      modal-classes="modal-secondary"
      size="lg"
    >
      <div class="" slot="header">
        <h2 id="">
          {{ $t("COMMON.CONFIRMATION") }}
        </h2>
      </div>
      <div class="">
        <div class="row">
          <p class="text-lg text-center">
            {{
              $t("SIGNATURES.SAME_SIGNATURES", {
                name: signature.name,
              })
            }}
          </p>
        </div>
        <div class="page-wrapper-table-body">
          <div class="page-wrapper-table-body-inner">
            <el-table
              class="align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="signatures"
            >
              <div class="table-loading" slot="empty" v-if="loading">
                <img src="/img/loading.gif" alt="" />
              </div>
              <el-table-column
                :label="$t('COMMON.NAME')"
                min-width="250"
                prop="name"
              >
                <template v-slot="{ row }">
                  <span>
                    {{ `${row.name}` }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('COMMON.EXCERPT')" min-width="300">
                <template v-slot="{ row }">
                  {{ row.description ?? "" }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <template slot="footer">
        <button
          type="submit"
          class="btn btn-primary"
          @click="continueFormSubmitProcess"
          :disabled="loading || processing"
        >
          <span v-if="loading || processing" class="btn-inner--icon">
            <i class="fas fa-spinner fa-spin"></i>
          </span>
          {{ $t("COMMON.CONTINUE") }}
        </button>

        <button
          type="button"
          class="btn btn-link ml-auto"
          @click="toggleSignatureCheckModalState"
          :disabled="loading || processing"
        >
          {{ $t("COMMON.CANCEL") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { cloneDeep } from "lodash";
import {
  Option,
  Select,
  Table,
  TableColumn,
  Form,
  FormItem,
  Button,
  Checkbox,
  Divider,
} from "element-ui";
import formMixin from "@/mixins/form-mixin";
import ValidationError from "@/components/ValidationError.vue";
import ContractSelector from "../../ContractManagement/components/ContractSelector.vue";
import FileListComponent from "../../ContractManagement/components/files/partials/FileListComponent.vue";
import { CONTRACT_TYPES } from "@/constants/contracts";
import OrganizationSelector from "@/components/OrganizationSelector.vue";
import AddressesSelector from "@/components/AddressesSelector.vue";
import ContractFieldsForm from "../../ContractManagement/components/ContractFieldsForm.vue";
export default {
  name: "SignatureForm",
  layout: "DashboardLayout",

  components: {
    ValidationError,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Divider.name]: Divider,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    ContractSelector,
    FileListComponent,
    OrganizationSelector,
    AddressesSelector,
    ContractFieldsForm,
  },

  mixins: [formMixin],

  props: [
    "hideOrganization",
    "signatureData",
    "formErrors",
    "loading",
    "hideSubmit",
  ],
  data() {
    let signatureData = { ...this.signatureData };
    signatureData = this.$fillUserOrganizationData(signatureData);
    if (!signatureData.meta) {
      signatureData.meta = {
        language: 'fr',
        timezone: 'GMT',
      };
    }
    return {
      usingOneSpanSignatureModel: false,
      sendNow: false,
      fromModel: false,
      contractType: null,
      signature: signatureData,
      signatures: [],
      total: 0,
      showModal: false,
      showSignatureCheckModal: false,
      processing: false,
      CONTRACT_TYPES: CONTRACT_TYPES,
      disableTemplateSelection: false,
      modelPayloadIsValid: false,
      mustProvidePayload: false,
      onespanLanguages: [{"id":"en","label":"Anglais (États-Unis)"},{"id":"da","label":"Danois"},{"id":"de","label":"Allemand"},{"id":"en-GB","label":"Anglais (Royaume-Uni)"},{"id":"es","label":"Espagnol (Amérique latine)"},{"id":"es-ES","label":"Espagnol (Espagne)"},{"id":"fr","label":"Français"},{"id":"it","label":"Italien"},{"id":"nl","label":"Néerlandais"},{"id":"no","label":"Norvégien"},{"id":"pl","label":"Polonais"},{"id":"pt","label":"Portugais"},{"id":"ro","label":"Roumain"},{"id":"bg","label":"Bulgare"},{"id":"ru","label":"Russe"},{"id":"zh-CN","label":"Chinois simplifié"},{"id":"zh-TW","label":"Chinois traditionnel"},{"id":"ja","label":"Japonais"},{"id":"ko","label":"Coréen"},{"id":"el","label":"Grec"},{"id":"ar","label":"Arabe"}],
      onespanTimezones: [{"id":"Etc/GMT+12","label":"(GMT-12:00) Temps moyen de Greenwich -12"},{"id":"Pacific/Samoa","label":"(GMT-11:00) Pacifique/Samoa"},{"id":"US/Samoa","label":"(GMT-11:00) États-Unis/Samoa"},{"id":"HST","label":"(GMT-10:00) Heure standard de Hawaï"},{"id":"Pacific/Honolulu","label":"(GMT-10:00) Pacifique/Honolulu"},{"id":"Pacific/Marquesas","label":"(GMT-9:30) Pacifique/Marquises"},{"id":"Pacific/Gambier","label":"(GMT-9:00) Pacifique/Gambier"},{"id":"US/Alaska","label":"(GMT-9:00) États-Unis/Alaska"},{"id":"America/Los_Angeles","label":"(GMT-8:00) Amérique/Los Angeles"},{"id":"America/Tijuana","label":"(GMT-8:00) Amérique/Tijuana"},{"id":"Canada/Pacific","label":"(GMT-8:00) Canada/Pacifique"},{"id":"PST","label":"(GMT-8:00) Pacifique"},{"id":"America/Vancouver","label":"(GMT-8:00) Amérique/Vancouver"},{"id":"America/Denver","label":"(GMT-7:00) Amérique/Denver"},{"id":"Canada/Mountain","label":"(GMT-7:00) Canada/Montagnes"},{"id":"America/Phoenix","label":"(GMT-7:00) Amérique/Phoenix"},{"id":"CST","label":"(GMT-6:00) Heure standard du Centre"},{"id":"Canada/Central","label":"(GMT-6:00) Canada/Centre"},{"id":"US/Central","label":"(GMT-6:00) États-Unis/Centre"},{"id":"America/Regina","label":"(GMT-6:00) Amérique/Regina"},{"id":"America/Chicago","label":"(GMT-6:00) Amérique/Chicago"},{"id":"Canada/Saskatchewan","label":"(GMT-6:00) Canada/Saskatchewan"},{"id":"America/Bogota","label":"(GMT-5:00) Amérique/Bogota"},{"id":"America/Toronto","label":"(GMT-5:00) Amérique/Toronto"},{"id":"EST","label":"(GMT-5:00) Heure standard de l'Est"},{"id":"US/Eastern","label":"(GMT-5:00) États-Unis/Est"},{"id":"America/Detroit","label":"(GMT-5:00) Amérique/Détroit"},{"id":"America/Jamaica","label":"(GMT-5:00) Amérique/Jamaïque"},{"id":"America/Montreal","label":"(GMT-5:00) Amérique/Montréal"},{"id":"America/Panama","label":"(GMT-5:00) Amérique/Panama"},{"id":"America/Caracas","label":"(GMT-4:30) Amérique/Caracas"},{"id":"America/Puerto_Rico","label":"(GMT-4:00) Amérique/Porto Rico"},{"id":"Canada/Atlantic","label":"(GMT-4:00) Canada/Atlantique"},{"id":"America/Antigua","label":"(GMT-4:00) Amérique/Antigua"},{"id":"America/Barbados","label":"(GMT-4:00) Amérique/Barbade"},{"id":"America/Santiago","label":"(GMT-4:00) Amérique/Santiago"},{"id":"America/St_Johns","label":"(GMT-3:30) Amérique/Saint-Jean de Terre-Neuve"},{"id":"CNT","label":"(GMT-3:30) Heure du Canada et de Terre-Neuve"},{"id":"Canada/Newfoundland","label":"(GMT-3:30) Canada/Terre-Neuve"},{"id":"America/Argentina/Buenos_Aires","label":"(GMT-3:00) Amérique/Argentine/Buenos Aires"},{"id":"Brazil/East","label":"(GMT-3:00) Brésil/Est"},{"id":"Atlantic/South_Georgia","label":"(GMT-2:00) Atlantique/Géorgie du Sud"},{"id":"Brazil/DeNoronha","label":"(GMT-2:00) Brésil/Fernando de Noronha"},{"id":"Atlantic/Azores","label":"(GMT-1:00) Atlantique/Açores"},{"id":"Atlantic/Cape_Verde","label":"(GMT-1:00) Atlantique/Cap-Vert"},{"id":"Africa/Casablanca","label":"(GMT 0:00) Afrique/Casablanca"},{"id":"GMT","label":"(GMT 0:00) Heure de Greenwich"},{"id":"Etc/Greenwich","label":"(GMT 0:00) Greenwich"},{"id":"Europe/London","label":"(GMT 0:00) Europe/Londres"},{"id":"Iceland","label":"(GMT 0:00) Islande"},{"id":"Africa/Lagos","label":"(GMT+1:00) Afrique/Lagos"},{"id":"CET","label":"(GMT+1:00) Heure d'Europe centrale"},{"id":"Europe/Paris","label":"(GMT+1:00) Europe/Paris"},{"id":"Europe/Zurich","label":"(GMT+1:00) Europe/Zurich"},{"id":"Europe/Amsterdam","label":"(GMT+1:00) Europe/Amsterdam"},{"id":"Europe/Madrid","label":"(GMT+1:00) Europe/Madrid"},{"id":"Europe/Copenhagen","label":"(GMT+1:00) Europe/Copenhague"},{"id":"Europe/Prague","label":"(GMT+1:00) Europe/Prague"},{"id":"Europe/Rome","label":"(GMT+1:00) Europe/Rome"},{"id":"Europe/Stockholm","label":"(GMT+1:00) Europe/Stockholm"},{"id":"Europe/Warsaw","label":"(GMT+1:00) Europe/Varsovie"},{"id":"ART","label":"(GMT+2:00) Heure d'Argentine"},{"id":"Africa/Cairo","label":"(GMT+2:00) Afrique/Le Caire"},{"id":"Asia/Istanbul","label":"(GMT+2:00) Asie/Istanbul"},{"id":"Europe/Helsinki","label":"(GMT+2:00) Europe/Helsinki"},{"id":"Africa/Addis_Ababa","label":"(GMT+3:00) Afrique/Addis-Abeba"},{"id":"Africa/Nairobi","label":"(GMT+3:00) Afrique/Nairobi"},{"id":"Asia/Tehran","label":"(GMT+3:30) Asie/Téhéran"},{"id":"Asia/Dubai","label":"(GMT+4:00) Asie/Dubaï"},{"id":"Europe/Moscow","label":"(GMT+4:00) Europe/Moscou"},{"id":"NET","label":"(GMT+4:00) Heure du Proche-Orient"},{"id":"Asia/Kabul","label":"(GMT+4:30) Asie/Kaboul"},{"id":"Asia/Karachi","label":"(GMT+5:00) Asie/Karachi"},{"id":"Asia/Kolkata","label":"(GMT+5:30) Asie/Kolkata"},{"id":"IST","label":"(GMT+5:30) Heure standard d'Inde"},{"id":"Asia/Katmandu","label":"(GMT+5:45) Asie/Katmandou"},{"id":"Asia/Dhaka","label":"(GMT+6:00) Asie/Dhaka"},{"id":"Asia/Rangoon","label":"(GMT+6:30) Asie/Rangoun"},{"id":"Asia/Bangkok","label":"(GMT+7:00) Asie/Bangkok"},{"id":"Asia/Jakarta","label":"(GMT+7:00) Asie/Jakarta"},{"id":"VST","label":"(GMT+7:00) Heure du Vietnam"},{"id":"Asia/Hong_Kong","label":"(GMT+8:00) Asie/Hong Kong"},{"id":"Australia/Perth","label":"(GMT+8:00) Australie/Perth"},{"id":"CTT","label":"(GMT+8:00) Heure standard de Chine"},{"id":"Australia/Eucla","label":"(GMT+8:45) Australie/Eucla"},{"id":"Asia/Seoul","label":"(GMT+9:00) Asie/Séoul"},{"id":"Asia/Tokyo","label":"(GMT+9:00) Asie/Tokyo"},{"id":"JST","label":"(GMT+9:00) Heure standard du Japon"},{"id":"ACT","label":"(GMT+9:30) Heure d'Australie, Centre"},{"id":"Australia/Adelaide","label":"(GMT+9:30) Australie/Adélaïde"},{"id":"Australia/Darwin","label":"(GMT+9:30) Australie/Darwin"},{"id":"AET","label":"(GMT+10:00) Heure d'Australie, Est"},{"id":"Australia/Brisbane","label":"(GMT+10:00) Australie/Brisbane"},{"id":"Australia/Sydney","label":"(GMT+10:00) Australie/Sydney"},{"id":"Australia/Canberra","label":"(GMT+10:00) Australie/Canberra"},{"id":"Australia/LHI","label":"(GMT+10:30) Australie/Île Lord Howe"},{"id":"Australia/Lord_Howe","label":"(GMT+10:30) Australie/Lord Howe"},{"id":"Asia/Vladivostok","label":"(GMT+11:00) Asie/Vladivostok"},{"id":"SST","label":"(GMT+11:00) Heure standard des Samoa"},{"id":"Pacific/Norfolk","label":"(GMT+11:30) Pacifique/Norfolk"},{"id":"Antarctica/South_Pole","label":"(GMT+12:00) Antarctique/Pôle Sud"},{"id":"NST","label":"(GMT+12:00) Heure standard de Terre-Neuve"},{"id":"Pacific/Auckland","label":"(GMT+12:00) Pacifique/Auckland"},{"id":"NZ-CHAT","label":"(GMT+12:45) Nouvelle-Zélande/Chatham"},{"id":"Pacific/Chatham","label":"(GMT+12:45) Pacifique/Chatham"},{"id":"MIT","label":"(GMT+13:00) Heure de l'Île du Millénaire"},{"id":"Pacific/Tongatapu","label":"(GMT+13:00) Pacifique/Tongatapu"},{"id":"Pacific/Kiritimati","label":"(GMT+14:00) Pacifique/Île Christmas"}]
    };
  },

  created() {
    if (this.signature?.contract?.id) {
      this.fromModel = true;
      this.usingOneSpanSignatureModel = true;
      this.disableTemplateSelection = true;
    } else {
      this.fromModel = false;
      this.usingOneSpanSignatureModel = false;
      if (this.signature?.token) {
        this.disableTemplateSelection = true;
      } else {
        this.disableTemplateSelection = false;
      }
    }
    if (this.signature.fields?.length) {
      this.mustProvidePayload = true;
    }
  },

  mounted() {},

  computed: {
    isEditing() {
      return !!this.signature.id;
    },
    canRemoveSigner() {
      if (this.usingOneSpanSignatureModel) {
        return false;
      }
      return true;
    },
  },

  methods: {
    contractSelected(contract) {
      this.usingOneSpanSignatureModel = contract.token != null;
      this.signature.contract = {
        type: "contracts",
        id: contract.id,
      };
      this.signature.name = contract.name;
      this.signature.documents = contract.documents ? cloneDeep(contract.documents) : [];
      this.signature.description = contract.excerpt;
      this.signature.email_message = contract.email_message;
      this.signature.fields = contract.fields ?? [];
      this.signature.meta = Object.assign(this.signature.meta || {}, contract.meta || {});
      this.signature.signers = [];
      if (contract.roles?.length) {
        this.addSignersFromRoles(contract.roles);
      }
      if (this.signature.fields?.length) {
        this.mustProvidePayload = true;
      }
    },
    openOrCloseModelSelector() {
      this.usingOneSpanSignatureModel = false;
      this.signature.signers = [];
      this.signature.name = "";
      this.signature.description = "";
      this.signature.email_message = "";
      this.signature.contract.id = null;
    },
    async handleSubmit() {
      const checkUniqueSignature = await this.checkSignatureUniqueInformation();
      if (checkUniqueSignature) {
        await this.sendInformation();
      } else {
        this.showSignatureCheckModal = true;
      }
    },

    async sendInformation() {
      if (this.signature.name) {
        this.signature.name = this.signature.name.toString();
      }
      let signatureData = cloneDeep(this.signature);
      signatureData = this.$fillUserOrganizationData(signatureData);
      if (
        signatureData.contract == null ||
        signatureData.contract?.id == null
      ) {
        delete signatureData.contract;
      }
      if (this.sendNow) {
        signatureData.sendNow = 1;
      }

      let documentsToReplace = [];
      if (signatureData.documents) {
        signatureData.documents.forEach((doc) => {
          if (doc.base64) {
            documentsToReplace.push({
              target_name: doc.name,
              base64: doc.base64,
              name: doc.replacement_file_name || doc.name,
            });
          }
        });
      }
      if (documentsToReplace.length) {
        signatureData.documents = documentsToReplace;
      } else {
        delete signatureData.documents;
      }
      
      this.$emit("signatureSubmitted", signatureData);
    },

    cancelEdition() {
      this.$emit("cancelEdition");
    },

    handleDocumentReplacement(event, row) {
      const file = event.target.files[0];
      if (file) {
        this.$set(row, "replacement_file", file);
        this.$set(row, "replacement_file_name", file.name);
        
        const reader = new FileReader();
        reader.onload = (e) => {
          this.$set(row, "base64", e.target.result.split(',')[1]);
        };
        reader.readAsDataURL(file);
      }
    },
    removeReplacement(row) {
      this.$set(row, "replacement_file", null);
      this.$set(row, "replacement_file_name", null);
      this.$set(row, "base64", null);
    },

    onFormChanged() {
      this.$emit("formChanged");
    },

    async getList() {
      if (!this.signature?.name) {
        return;
      }
      try {
        this.processing = true;
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...{
              search: `${this.signature?.name}`,
            },
          },
          page: {
            number: 1,
            size: 999,
          },
        };
        await this.$store.dispatch("signatures/list", params);
        this.signatures = this.$store.getters["signatures/list"];
        this.total = this.$store.getters["signatures/listTotal"];
        this.processing = false;
      } catch (error) {
        this.processing = false;
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async checkSignatureUniqueInformation() {
      await this.getList();
      switch (this.total) {
        case 0:
          return true;
        case 1:
          return !!this.signature?.id;
        default:
          return false;
      }
    },

    async continueFormSubmitProcess() {
      this.processing = true;
      await this.toggleSignatureCheckModalState();
      await this.sendInformation();
      this.processing = false;
    },

    async toggleSignatureCheckModalState() {
      this.showSignatureCheckModal = !this.showSignatureCheckModal;
    },

    checkSignatureInformation() {
      if (this.mustProvidePayload) {
        this.modelPayloadIsValid =
          this.$refs["contract_fields_form"].checkInformation();
      }
      this.$refs["signatureForm"].validate(async (valid) => {
        if (valid) {
          if (this.mustProvidePayload) {
            if (this.modelPayloadIsValid) {
              this.handleSubmit();
            } else {
              return;
            }
          } else {
            this.handleSubmit();
          }
        }
      });
    },

    // Méthode pour ajouter un signataire
    addSignersFromRoles(roles) {
      roles.forEach((role) => {
        this.signature.signers.push({
          role: role,
          firstname: "",
          lastname: "",
          address: "",
          phone: "",
          email: "",
        });
      });
    },

    addSigner() {
      let roleKey = this.signature.signers.length + 1;
      this.signature.signers.push({
        role: "Signataire" + roleKey,
        firstname: "",
        lastname: "",
        address: "",
        phone: "",
        email: "",
      });
    },
    // Méthode pour supprimer un signataire
    async removeSigner(index) {
      const signer = this.signature.signers[index];
      /* if (this.signature.id && signer.role) {
        try {
          await this.$store.dispatch("signatures/deleteSigner", {
            signatureId: this.signature.id,
            signerId: signer.role,
          });
          this.$notify({
            type: "success",
            message: this.$t("SIGNATURES.SIGNER_DELETED"),
          });
        } catch (error) {
          this.$notify({
            type: "danger",
            message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
          });
          return;
        }
      } */
      this.signature.signers.splice(index, 1);
    },

    validateUniqueRole(rule, value, callback) {
      if (!value) {
        return callback();
      }
      const roles = this.signature.signers.map((s) => s.role);
      const count = roles.filter((r) => r === value).length;
      if (count > 1) {
        callback(new Error(this.$t("SIGNATURES.ROLE_MUST_BE_UNIQUE")));
      } else {
        callback();
      }
    },

    async toggleModalState() {
      this.showModal = !this.showModal;
    },
  },

  watch: {
    formErrors(errors) {
      if (errors) {
        this.setApiValidation(errors);
      }
    },
    signatureData(signatureData) {
      if (signatureData) {
        this.signature = {
          ...this.signature,
          ...cloneDeep(signatureData),
        };
      }
    },
  },
};
</script>

<style>
.add-form .btn-cancel {
  font-size: 14px;
  min-height: 40px;
  border-radius: 8px;
  padding: 0 15px;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  color: #fff;
}

.add-form .el-input__inner,
.add-form .el-textarea {
  background-color: transparent;
  border-radius: 8px;
  color: #000;
}
.form-group-wrapper-item .el-select {
  width: 100%;
}
.form-group-wrapper-item label {
  margin-bottom: 0.1rem !important;
}
.form-group-wrapper-item .el-form-item__label {
  padding: 0 0 1px !important;
}
</style>
